<template>
    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 128 128" width="64px" height="64px"><path d="M29 77c7.2 0 13-5.8 13-13s-5.8-13-13-13-13 5.8-13 13S21.8 77 29 77zM29 57c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7S25.1 57 29 57zM29 112c7.2 0 13-5.8 13-13s-5.8-13-13-13-13 5.8-13 13S21.8 112 29 112zM29 92c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7S25.1 92 29 92zM29 42c7.2 0 13-5.8 13-13s-5.8-13-13-13-13 5.8-13 13S21.8 42 29 42zM29 22c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7S25.1 22 29 22zM54 32h54c1.7 0 3-1.3 3-3s-1.3-3-3-3H54c-1.7 0-3 1.3-3 3S52.3 32 54 32zM54 67h54c1.7 0 3-1.3 3-3s-1.3-3-3-3H54c-1.7 0-3 1.3-3 3S52.3 67 54 67zM54 102h54c1.7 0 3-1.3 3-3s-1.3-3-3-3H54c-1.7 0-3 1.3-3 3S52.3 102 54 102z"/></svg>
</template>

<script>
export default {
  name: 'List'
}
</script>